import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Uptime',
  slug: 'uptime',
  definition: `Uptime is the percentage of time a service, server, or application is operational and accessible to users. It is the primary metric used to evaluate the reliability of any online system.

Uptime is typically expressed as a percentage over a given period. For example, 99.9% uptime over a month means the service was down for roughly 43 minutes total. The higher the percentage, the more reliable the service.

The opposite of uptime is downtime — any period where the service is unreachable or not functioning correctly. Even brief interruptions can affect user trust and revenue.`,
  whyItMatters: `Uptime directly impacts revenue, user trust, and brand reputation. An e-commerce site losing uptime during peak hours can lose thousands of dollars per minute. SaaS products with poor uptime see higher churn rates.

Beyond direct financial impact, uptime affects SEO rankings. Search engines penalize sites that are frequently unavailable, pushing them lower in results. For businesses that depend on organic traffic, poor uptime has compounding effects.`,
  howUptrackHelps: `Uptrack checks your endpoints every 30 seconds on every plan, detecting downtime 10x faster than tools that check every 5 minutes. When a check fails, Uptrack runs confirmation checks to verify the outage before alerting you, so you only get notified about real problems.

You get a clear uptime percentage for each monitor over any time window, making it easy to track reliability trends and report on SLA compliance.`,
  formula: 'Uptime % = (Total Time - Downtime) / Total Time x 100',
  relatedTerms: [
    { name: 'Downtime', href: '/glossary/downtime' },
    { name: 'SLA', href: '/glossary/sla' },
    { name: 'Five Nines', href: '/glossary/five-nines' },
    { name: 'MTTR', href: '/glossary/mttr' },
  ],
}

export const Route = createFileRoute('/_site/glossary/uptime')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
